import React, { useCallback, useEffect, useState } from "react";
import "../../../src/style.css";
import { useNavigate } from "react-router-dom";
import { makeStyles, ThemeProvider } from "@mui/styles";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import {
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
} from "@mui/material";
import {
  DataGrid,
  GridToolbar,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarFilterButton,
} from "@mui/x-data-grid";
import Delete from "@mui/icons-material/Delete";
import Edit from "@mui/icons-material/Edit";
import Visibility from "@mui/icons-material/Visibility";
import Close from "@mui/icons-material/Close";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CloseIcon from "@mui/icons-material/Close";
import {
  createRedirectCampaign,
  deleteRedirectCampaign,
  getRedirectCampaign,
  updateRedirectCampaign,
} from "../../redux/actions/redirectPortal/redirectPortal_campaignAction";
import { useDispatch, useSelector } from "react-redux";
import DeleteIcon from "@mui/icons-material/Delete";
import { createRedirectBuyer } from "../../redux/actions/redirectPortal/redirectPortal_buyerAction";
import { LocalizationProvider, MobileTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import dayjs from "dayjs";
import PageTitle from "../../components/common/PageTitle";

const useStyles = makeStyles({
  borderedGreen: {
    borderLeft: "3px solid green", // Add your border styling here
    boxShadow: "2px -1px 4px -3px #686868",
    margin: "4px 4px 1px 4px !important",
  },
  borderedRed: {
    borderLeft: "3px solid red", // Add your border styling here
    boxShadow: "2px -1px 4px -3px #686868",
    margin: "4px 4px 1px 4px !important",
  },
  formControl: {
    "& .MuiInputBase-root": {
      color: "#666",
      borderColor: "transparent",
      borderWidth: "1px",
      borderStyle: "solid",
      height: "45px",
      minWidth: "120px",
      justifyContent: "center",
    },
    "& .MuiSelect-select.MuiSelect-select": {
      paddingRight: "0px",
    },
    "& .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root": {
      top: "-4px",
    },
  },
  select: {
    width: "auto",
    fontSize: "12px",
    "&:focus": {
      backgroundColor: "transparent",
    },
  },
  selectIcon: {
    position: "relative",
    color: "#6EC177",
    fontSize: "14px",
  },
  paper: {
    borderRadius: 12,
    marginTop: 8,
  },
  list: {
    paddingTop: 0,
    paddingBottom: 0,
    "& li": {
      fontWeight: 200,
      paddingTop: 8,
      paddingBottom: 8,
      fontSize: "12px",
    },
    "& li.Mui-selected": {
      color: "white",
      background: "#6EC177",
    },
    "& li.Mui-selected:hover": {
      background: "#6EC177",
    },
  },
});

function CustomToolbar() {
  return (
    <GridToolbarContainer
      sx={{
        "& .MuiButton-root": {
          fontSize: {
            xs: "12px", // mobile
            sm: "14px", // tablet
            md: "14px", // desktop
          },
          minWidth: "auto",
        },
        "& .MuiSvgIcon-root": {
          fontSize: {
            xs: "16px",
            sm: "18px",
          },
        },
      }}
    >
      <GridToolbarColumnsButton />
      <GridToolbarDensitySelector />
      <GridToolbarFilterButton />
      {/* <GridToolbarExport /> */}
    </GridToolbarContainer>
  );
}

const InitialValues = {
  buyerId: "",
  buyerName: "",
  status: "",
  forwardNumber: "",
  cc: "",
  weightage: "",
  dailyLimit: "",
  redirectId: "",
  fromDate: null,
  toDate: null,
  followWorkTime: false,
  ringTimeout: 60,
};

function Campaigns({ userThem }) {
  const current_user = localStorage.getItem("current_user");
  const user_id = JSON.parse(localStorage.getItem(`user_${current_user}`));
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const [open, setOpen] = useState(false);
  const [response, setResponse] = useState("");
  const [campaignId, setCampaignId] = useState("");
  const [buyerOpen, setBuyerOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [campaignName, setCampaignName] = useState("");
  const [strategy, setStrategy] = useState("");
  const [status, setStatus] = useState("");
  const [description, setDescription] = useState("");
  const [alertMessage, setAlertMessage] = useState(false);
  const [selectedDescription, setSelectedDescription] = useState("");
  const [descModal, setDescModal] = useState(false);
  const [callThreading, setCallThreading] = useState(false);
  const [id, setId] = useState("");
  const [name, setName] = useState("");
  const [buyerData, setBuyerData] = useState(InitialValues);
  const [routeInfo, setRouteInfo] = useState(false);

  const [errors, setErrors] = useState({
    buyerName: "",
    forwardNumber: "",
    fromDate: "",
    toDate: "",
  });

  const navigate = useNavigate();
  const classes = useStyles();
  const handleOpen = () => setOpen(true);

  const handleClose = () => {
    setOpen(false);
    setCampaignName("");
    setDescription("");
    setCallThreading(false);
  };

  const handleAlertClose = () => {
    setAlertMessage(false);
  };

  const handleAddBuyerOpen = (data) => {
    setBuyerOpen(true);
    setCampaignId(data?.campaignId);
  };

  const handleAddBuyerClose = () => {
    setBuyerOpen(false);
    setBuyerData({
      buyerId: "",
      buyerName: "",
      status: "",
      forwardNumber: "",
      cc: "",
      weightage: "",
      dailyLimit: "",
      redirectId: "",
      fromDate: null,
      toDate: null,
      followWorkTime: false,
      ringTimeout: 60,
    });
    setErrors({ buyerName: "", forwardNumber: "" });
    setRouteInfo(false);
  };

  const handleEditCampaignOpen = () => setEdit(true);

  const handleEditCampaignClose = () => {
    setEdit(false);
    setCampaignName("");
    setDescription("");
    setRouteInfo(false);
  };

  useEffect(() => {
    dispatch(getRedirectCampaign());
  }, [response]);

  const checkValidation = useCallback(() => {
    let isValid = true;
    const { buyerName, forwardNumber, fromDate, toDate } = buyerData;
    const newErrors = {
      buyerName: "",
      forwardNumber: "",
      fromDate: "",
      toDate: "",
    };

    // ✅ Forward Number validations
    if (!/\d/.test(forwardNumber)) {
      newErrors.forwardNumber = "Forward Number must include numbers (0-9)";
      isValid = false;
    } else if (forwardNumber.length !== 11) {
      newErrors.forwardNumber = "Forward Number should be exactly 11 digits";
      isValid = false;
    } else if (/\s/.test(forwardNumber)) {
      newErrors.forwardNumber = "Forward Number cannot contain spaces";
      isValid = false;
    }

    // ✅ Buyer Name validation
    if (buyerName.trim().length < 3) {
      newErrors.buyerName = "Buyer Name must be at least 3 characters";
      isValid = false;
    }

    // ✅ From Date validation
    if (buyerData.followWorkTime === true && !fromDate) {
      if (!fromDate) {
        newErrors.fromDate = "Start Time is required";
        isValid = false;
      }
    }
    if (buyerData.followWorkTime === true && !toDate) {
      // ✅ To Date validation
      if (!toDate) {
        newErrors.toDate = "End Time is required";
        isValid = false;
      }
    }

    setErrors(newErrors);
    return isValid;
  }, [buyerData]);

  const handleOpenDesc = (description) => {
    setSelectedDescription(description);
    setDescModal(true);
  };

  const handleCloseDesc = () => setDescModal(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setBuyerData((prevData) => ({
      ...prevData,
      [name]: name === "forwardNumber" ? value.trim() : value,
    }));
    switch (name) {
      case "campaignName":
        setCampaignName(value);
        break;
      case "strategy":
        setStrategy(value);
        break;
      case "status":
        setStatus(value);
        break;
      case "description":
        setDescription(value);
        break;
      default:
        break;
    }
  };

  const handleFromDateChange = (date) => {
    if (dayjs(date, "HH:mm", true).isValid()) {
      setBuyerData((prevData) => ({
        ...prevData,
        fromDate: dayjs(date).format("HH:mm"),
      }));
    } else {
      setBuyerData((prevData) => ({
        ...prevData,
        fromDate: null,
      }));
    }
  };

  const handleToDateChange = (date) => {
    if (dayjs(date, "HH:mm", true).isValid()) {
      setBuyerData((prevData) => ({
        ...prevData,
        toDate: dayjs(date).format("HH:mm"),
      }));
    } else {
      setBuyerData((prevData) => ({
        ...prevData,
        toDate: null,
      }));
    }
  };

  const handleSubmit = () => {
    const data = JSON.stringify({
      user_id: user_id.uid,
      group_name: campaignName,
      description: description,
      call_threading: callThreading,
      route_info: routeInfo,
    });
    dispatch(createRedirectCampaign(data, setResponse, handleClose));
  };

  const handleSubmitBuyer = (e) => {
    e.preventDefault();
    const isValid = checkValidation();
    if (isValid) {
      let data = JSON.stringify({
        redirect_group_id: campaignId,
        buyer_name: buyerData.buyerName,
        forward_number: buyerData.forwardNumber,
        cc: buyerData.cc,
        weightage: buyerData.weightage,
        daily_limit: buyerData.dailyLimit,
        working_start_time: buyerData.fromDate,
        working_end_time: buyerData.toDate,
        follow_working_time: buyerData.followWorkTime === false ? "f" : "t",
        ring_timeout: JSON.parse(buyerData.ringTimeout),
      });
      dispatch(createRedirectBuyer(data, setResponse, handleAddBuyerClose));
    }
  };

  const handleUpdate = () => {
    const data = JSON.stringify({
      id: campaignId,
      user_id: user_id.uid,
      group_name: campaignName,
      description: description,
      call_threading: callThreading,
      route_info: routeInfo,
    });
    dispatch(
      updateRedirectCampaign(data, setResponse, handleEditCampaignClose),
    );
  };

  const handleMessage = useCallback(
    (data) => {
      setName(data?.group_name);
      setId(data?.campaignId);
      setAlertMessage(true);
    },
    [setName],
  ); // Memoize event handler

  const handleDelete = useCallback(() => {
    dispatch(deleteRedirectCampaign(JSON.stringify({ id: id }), setResponse));
    setAlertMessage(false);
  }, [dispatch, setResponse, id]);

  const handleEdit = (data) => {
    handleEditCampaignOpen();
    setCampaignName(data?.group_name);
    setDescription(data?.description);
    setCampaignId(data?.campaignId);
    setCallThreading(data?.call_threading);
    setRouteInfo(data?.route_info);
  };

  const handleView = (data) => {
    navigate("/redirect_portal/buyer_view", { state: { data: data } });
  };

  // --------------Columns Data Condition For Mobile View and Desktop View---------------------
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only("xs")); // < 600px
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const columns = [
    {
      field: "view_buyer",
      headerName: "View Buyer",
      headerClassName: "redirect_custom-header",
      flex: 1,
      width: isXs ? 100 : "100%",
      minWidth: 100,
      maxWidth: "100%",
      headerAlign: "left",
      disableColumnMenu: true, // Prevents menu on hover
      sortable: false, // Allows sorting on click but not on hover
      align: "left",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{ fontSize: "calc(0.5rem + 0.3vw)", fontWeight: "bold" }}
        >
          View Buyer
        </Typography>
      ),
      renderCell: (params) => {
        return (
          <div className="d-flex justify-content-between align-items-left">
            <Tooltip title="View">
              <IconButton
                onClick={() => handleView(params.row)}
                sx={{ padding: "5px" }}
              >
                <Visibility
                  style={{
                    cursor: "pointer",
                    color: "#f5751D ",
                    fontSize: "calc(0.8rem + 0.8vw)",
                  }}
                />
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit">
              <IconButton
                onClick={() => handleEdit(params.row)}
                sx={{ padding: "5px" }}
              >
                <Edit
                  index={params.row.id}
                  style={{
                    cursor: "pointer",
                    color: "#42765f",
                    fontSize: "calc(0.8rem + 0.8vw)",
                  }}
                />
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete">
              <IconButton
                onClick={() => handleMessage(params.row)}
                sx={{ padding: "5px" }}
              >
                <Delete
                  style={{
                    cursor: "pointer",
                    color: "red",
                    fontSize: "calc(0.8rem + 0.8vw)",
                  }}
                />
              </IconButton>
            </Tooltip>
          </div>
        );
      },
    },
    {
      field: "group_name",
      headerName: "Campaign Name",
      headerClassName: "custom-header",
      flex: 1,
      width: isXs ? 77 : "100%",
      minWidth: 77,
      maxWidth: "100%",
      headerAlign: "left",
      disableColumnMenu: true, // Keeps column menu enabled
      sortable: false, // Disables sorting on both hover and click
      align: "left",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{ fontSize: "calc(0.5rem + 0.3vw)", fontWeight: "bold" }}
        >
          {isSmallScreen ? "Camp. Name" : "Campaign Name"}
        </Typography>
      ),
      renderCell: (params) => {
        return (
          <span sx={{ fontSize: "calc(0.4rem + 0.3vw)" }}>
            {params.row.group_name}
          </span>
        );
      },
    },
    // {
    //   field: "route_info",
    //   headerName: "Route Info",
    //   headerClassName: "custom-header",
    //   headerAlign: "start",
    //   align: "start",
    //   width: isXs ? 80 : 120,
    //   minWidth: 80,
    //   maxWidth: 120,
    //   renderHeader: () => (
    //     <Typography
    //       variant="body2"
    //       sx={{
    //         fontSize: "calc(0.6rem + 0.2vw)",
    //         fontWeight: "bold",
    //         color: "white !important",
    //       }}
    //     >
    //       {isSmallScreen ? "Route Info" : "Route Info"}
    //     </Typography>
    //   ),
    //   renderCell: (params) => (
    //     <Typography
    //       variant="body2"
    //       sx={{ fontSize: "calc(0.6rem + 0.2vw)" }} // Match header size or set your own
    //     >
    //       {params.row.route_info === true ? (
    //         <span style={{ color: "green" }}>Active</span>
    //       ) : (
    //         <span style={{ color: "red" }}>Deactive</span>
    //       )}
    //     </Typography>
    //   ),
    // },
    {
      field: "call_threading",
      headerName: "Call Threading",
      headerClassName: "custom-header",
      flex: 1,
      width: isXs ? 60 : "100%",
      minWidth: 60,
      maxWidth: "100%",
      headerAlign: "left",
      disableColumnMenu: true, // Keeps column menu enabled
      sortable: false, // Disables sorting on both hover and click
      align: "left",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{ fontSize: "calc(0.5rem + 0.3vw)", fontWeight: "bold" }}
        >
          {isSmallScreen ? "Call Thrd." : "Call Threading"}
        </Typography>
      ),
      renderCell: (params) => {
        return (
          <span
            style={{
              textTransform: "capitalize",
              fontSize: "calc(0.6rem + 0.3vw)",
            }}
          >
            {params.row.call_threading === true ? "Yes" : "No"}
          </span>
        );
      },
    },
    {
      field: "add_buyer",
      headerName: "Add Buyer",
      headerClassName: "custom-header",
      flex: 1,
      width: isXs ? 75 : "100%",
      minWidth: 75,
      maxWidth: "100%",
      disableColumnMenu: true, // Prevents menu on hover
      sortable: false, // Allows sorting on click but not on hover
      //headerClassName: "redirect_custom-header",
      headerAlign: "left",
      align: "left",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{ fontSize: "calc(0.5rem + 0.3vw)", fontWeight: "bold" }}
        >
          Add Buyer
        </Typography>
      ),
      renderCell: (params) => {
        return (
          <div
            className="d-flex justify-content-between align-items-center"
            style={{ cursor: "pointer" }}
            onClick={() => handleAddBuyerOpen(params.row)}
          >
            <div>
              <Typography
                sx={{
                  fontSize: "calc(0.6rem + 0.3vw)",
                  textTransform: "capitalize !important",
                  marginLeft: "0px !important",
                  marginRight: "0px !important",
                  // borderRadius:'5px',
                  background: "transparent",
                  color: "#f76b0b",
                  margin: "3px 0",
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
                // className="campaign_add_btn"
                color="error"
                onClick={() => handleAddBuyerOpen(params.row)}
                // startIcon={<Add />}
              >
                Add Buyer
              </Typography>
            </div>
          </div>
        );
      },
    },
    {
      field: "description",
      headerName: "Description",
      headerClassName: "custom-header",
      flex: 1,
      width: isXs ? 60 : "100%",
      minWidth: 60,
      maxWidth: "100%",
      disableColumnMenu: true, // Prevents menu on hover
      sortable: false, // Allows sorting on click but not on hover
      //headerClassName: "redirect_custom-header",
      headerAlign: "left",
      align: "left",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{ fontSize: "calc(0.6rem + 0.3vw)", fontWeight: "bold" }}
        >
          {isSmallScreen ? "Descrip." : "Description"}
        </Typography>
      ),
      renderCell: (params) => (
        <div
          style={{
            fontSize: "calc(0.6rem + 0.3vw)",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            cursor: "pointer",
            maxWidth: "100%",
            //color: "white",
          }}
          onClick={() => handleOpenDesc(params.value)}
          title="Click to expand"
        >
          {params.value.length > 50
            ? params.value.substring(0, 50) + "..."
            : params.value}
        </div>
      ),
    },
  ];

  const mockDataTeam = [];
  state?.getRedirectCampaign?.RedirectCampaign?.data &&
    state?.getRedirectCampaign?.RedirectCampaign?.data?.forEach(
      (item, index) => {
        mockDataTeam.push({
          id: index + 1,
          description: item.description,
          group_name: item.group_name,
          user_id: item.user_id,
          campaignId: item.id,
          call_threading: item.call_threading,
          route_info: item?.route_info,
        });
      },
    );
    
  return (
    <>
      {/* <div className="main"> */}
      <div className={`App ${userThem} `}>
        <div className="contant_box">
          <section className="sidebar-sec">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12">
                  <div className="">
                    {/* <!----> */}
                    <div className="tab-content" id="pills-tabContent">
                      <div
                        className="tab-pane fade show active"
                        id="pills-home"
                        role="tabpanel"
                        aria-labelledby="pills-home-tab"
                      >
                        {/* <!--role-contet--> */}

                        <div className="tab_cntnt_box">
                          <div
                            className="cntnt_title"
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <div>
                              <PageTitle title="Campaign" />
                              {/* <p>
                              A ring group is a set of destinations that can be
                              called with a ring strategy.
                            </p> */}
                            </div>

                            <Dialog
                              open={descModal}
                              onClose={handleCloseDesc}
                              fullWidth
                              maxWidth="sm"
                            >
                              <DialogTitle>
                                Full Description
                                <IconButton
                                  aria-label="close"
                                  onClick={handleCloseDesc}
                                  sx={{
                                    position: "absolute",
                                    right: 8,
                                    top: 8,
                                  }}
                                >
                                  <CloseIcon />
                                </IconButton>
                              </DialogTitle>
                              <DialogContent>
                                <p
                                  style={{
                                    wordBreak: "break-word",
                                    whiteSpace: "pre-wrap",
                                  }}
                                >
                                  {selectedDescription}
                                </p>
                              </DialogContent>
                            </Dialog>

                            {/* ========= */}
                            <box className="d-xxl-block d-xl-block d-lg-block d-md-block d-sm-none d-none">
                              <IconButton
                                className="all_button_clr"
                                onClick={handleOpen}
                              >
                                Add Campaign
                                <AddOutlinedIcon />
                              </IconButton>
                            </box>

                            {/* mobile_view_start */}
                            <box className="d-xxl-none d-xl-none d-lg-none d-md-none d-sm-block d-block">
                              <Button
                                sx={{
                                  fontSize: "15px",
                                  borderRadius: "5px",
                                  border: "none",
                                  color: "#fff",
                                  marginRight: "0px",
                                  px: 4,
                                  textTransform: "capitalize",
                                  height: "35px",
                                  width: "90px",
                                  minWidth: "90px",
                                  flexShrink: 0,
                                  display: "inline-flex",
                                  justifyContent: "space-evenly",
                                  alignItems: "center",
                                }}
                                className="redirect_all_button_clr"
                                onClick={handleOpen}
                              >
                                Add
                                <AddOutlinedIcon />
                              </Button>
                            </box>

                            {/* mobile_view_end*/}
                          </div>
                          {/* -----   Add Campaigns Modal Start   ----- */}

                          <Dialog
                            className="custom_dailog_box_user"
                            open={open}
                            onClose={handleClose}
                            sx={{ textAlign: "center" }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                paddingTop: "10px",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <Typography
                                className="modal_heading"
                                sx={{
                                  color: "#133325",
                                  fontWeight: "600",
                                  width: "500px",
                                }}
                              >
                                Add Campaign
                              </Typography>
                              <IconButton
                                className="close_icon"
                                onClick={handleClose}
                                sx={{ float: "inline-end" }}
                              >
                                <Close />
                              </IconButton>
                            </Box>

                            <DialogContent>
                              <form>
                                <form
                                  style={{
                                    textAlign: "center",

                                    paddingTop: "10px",
                                    padding: "5px",
                                    width: "auto",
                                  }}
                                >
                                  <TextField
                                    style={{
                                      width: "100%",
                                      margin: " 5px 0 5px 0",
                                    }}
                                    type="text"
                                    label="Campaign Name"
                                    variant="outlined"
                                    padding={"0px 0 !important"}
                                    value={campaignName}
                                    onChange={(e) =>
                                      setCampaignName(e.target.value)
                                    }
                                  />
                                  <FormControl
                                    fullWidth
                                    style={{
                                      width: "100%",
                                      margin: "7px 0",
                                    }}
                                  >
                                    <InputLabel id="demo-simple-select-label">
                                      Call Threading
                                    </InputLabel>

                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      label="Call Threading"
                                      helperText="Select the language."
                                      style={{ textAlign: "left" }}
                                      value={callThreading}
                                      onChange={(e) => {
                                        setCallThreading(e.target.value);
                                      }}
                                    >
                                      <MenuItem value={true}>Yes</MenuItem>
                                      <MenuItem value={false}>No</MenuItem>
                                    </Select>
                                  </FormControl>
                                  <br />
                                  <FormControl
                                    fullWidth
                                    style={{
                                      width: "100%",
                                      margin: "7px 0",
                                    }}
                                  >
                                    <InputLabel id="demo-simple-select-label">
                                      Route Info
                                    </InputLabel>

                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      label="Call Threading"
                                      helperText="Select the language."
                                      style={{ textAlign: "left" }}
                                      value={routeInfo}
                                      onChange={(e) => {
                                        setRouteInfo(e.target.value);
                                      }}
                                    >
                                      <MenuItem value={true}>Active</MenuItem>
                                      <MenuItem value={false}>
                                        Deactive
                                      </MenuItem>
                                    </Select>
                                  </FormControl>

                                  <TextField
                                    style={{
                                      width: "100%",
                                      margin: " 5px 0 5px 0",
                                    }}
                                    type="text"
                                    label="Description"
                                    variant="outlined"
                                    value={description}
                                    onChange={(e) =>
                                      setDescription(e.target.value)
                                    }
                                  />
                                </form>
                              </form>
                            </DialogContent>
                            <DialogActions
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                paddingBottom: "20px",
                              }}
                            >
                              <Button
                                variant="contained"
                                className="all_button_clr"
                                color="primary"
                                sx={{
                                  background: "#092b5f",
                                  marginTop: "0px",
                                }}
                                onClick={handleSubmit}
                              >
                                save
                              </Button>
                            </DialogActions>
                          </Dialog>

                          {/* -----   Add Campaigns Modal End   ----- */}

                          {/* Delete Confirmation Modal Start  */}
                          <Dialog
                            open={alertMessage}
                            onClose={handleAlertClose}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                            sx={{ textAlign: "center" }}
                            //className="bg_imagess"
                          >
                            <DialogTitle
                              id="alert-dialog-title"
                              sx={{ color: "#133325", fontWeight: "600" }}
                            >
                              {"Delete Confirmation"}
                            </DialogTitle>
                            <DialogContent>
                              <DialogContentText
                                id="alert-dialog-description"
                                sx={{ paddingBottom: "0px !important" }}
                              >
                                Are you sure you want to delete {name} ?
                              </DialogContentText>
                            </DialogContent>
                            <DialogActions
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                paddingBottom: "20px",
                              }}
                            >
                              <Button
                                variant="contained"
                                sx={{
                                  fontSize: "16px !impotant",
                                  background:
                                    "linear-gradient(180deg, #0E397F 0%, #001E50 100%) !important",
                                  marginTop: "0px",
                                  marginLeft: "0px !important",
                                  padding: "10px 20px !important",
                                  textTransform: "capitalize !important",
                                }}
                                className="all_button_clr"
                                color="info"
                                onClick={handleAlertClose}
                                autoFocus
                              >
                                Cancel
                              </Button>
                              <Button
                                variant="contained"
                                sx={{
                                  fontSize: "16px !impotant",
                                  marginTop: "0px",
                                  padding: "10px 20px !important",
                                  textTransform: "capitalize !important",
                                  marginLeft: "0px !important",
                                  marginRight: "0px !important",
                                }}
                                className="all_button_clr"
                                color="error"
                                onClick={handleDelete}
                                startIcon={<DeleteIcon />}
                              >
                                Delete
                              </Button>
                            </DialogActions>
                          </Dialog>
                          {/* Delete Confirmation Modal End  */}

                          {state?.getRedirectCampaign?.loading === true ? (
                            <>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  width: "90%",
                                  marginTop: "9rem !important",
                                }}
                              >
                                <CircularProgress />
                              </Box>
                            </>
                          ) : (
                            <>
                              <ThemeProvider theme={theme}>
                                <div style={{ height: "100%", width: "100%" }}>
                                  <DataGrid
                                    className="custom_header_redirect"
                                    rows={mockDataTeam}
                                    columns={columns}
                                    density="compact"
                                    // getRowClassName={(params) =>
                                    //   isRowBordered(params)
                                    //     ? "borderedGreen"
                                    //     : "borderedRed"
                                    // }
                                    components={{ Toolbar: GridToolbar }}
                                    slots={{
                                      toolbar: CustomToolbar,
                                    }}
                                    autoHeight // Automatically adjust the height to fit all rows
                                    disableColumnResize={false} // Allow column resizing
                                    hideFooterPagination={
                                      window.innerWidth < 600
                                    } // Hide pagination for small screens
                                    sx={{
                                      "& .MuiDataGrid-cell": {
                                        fontSize: {
                                          xs: "12px",
                                          sm: "14px",
                                          md: "14px",
                                        }, // Responsive font sizes
                                        wordBreak: "break-word !important", // Break long words
                                        whiteSpace: "break-spaces !important", // Allow multi-line text
                                      },
                                    }}
                                  />
                                </div>
                              </ThemeProvider>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    {/* -----   Add Buyer Modal Start   ----- */}
                    <Dialog
                      className="custom_dailog_box_user"
                      open={buyerOpen}
                      onClose={handleAddBuyerClose}
                      sx={{ textAlign: "center" }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          paddingTop: "10px",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography
                          className="modal_heading"
                          sx={{
                            color: "#133325",
                            fontWeight: "600",
                            width: "500px",
                          }}
                        >
                          Add Buyer
                        </Typography>
                        <IconButton
                          className="close_icon"
                          onClick={handleAddBuyerClose}
                          sx={{ float: "inline-end" }}
                        >
                          <Close />
                        </IconButton>
                      </Box>

                      <DialogContent>
                        <form
                          style={{
                            textAlign: "center",
                            paddingTop: "10px",

                            width: "auto",
                          }}
                        >
                          <Grid container spacing={1}>
                            {/* Buyer Name */}
                            <Grid item xs={12}>
                              <TextField
                                fullWidth
                                label="Buyer Name"
                                variant="outlined"
                                name="buyerName"
                                value={buyerData.buyerName}
                                onChange={(e) =>
                                  setBuyerData((prev) => ({
                                    ...prev,
                                    buyerName: e.target.value,
                                  }))
                                }
                                error={!!errors.buyerName}
                                helperText={errors.buyerName}
                              />
                            </Grid>

                            {/* Forward Number */}
                            <Grid item xs={12}>
                              <TextField
                                fullWidth
                                label="Forward Number"
                                variant="outlined"
                                value={buyerData.forwardNumber}
                                onChange={(e) => {
                                  const numericValue = e.target.value.replace(
                                    /[^0-9]/g,
                                    "",
                                  );
                                  setBuyerData((prev) => ({
                                    ...prev,
                                    forwardNumber: numericValue,
                                  }));
                                }}
                                error={!!errors.forwardNumber}
                                helperText={errors.forwardNumber}
                                inputProps={{ inputMode: "numeric" }}
                              />
                            </Grid>

                            {/* CC */}
                            <Grid item xs={12} md={6}>
                              <TextField
                                fullWidth
                                label="CC (Concurrent Call)"
                                value={buyerData.cc}
                                onChange={(e) =>
                                  setBuyerData((prev) => ({
                                    ...prev,
                                    cc: e.target.value,
                                  }))
                                }
                              />
                            </Grid>

                            {/* Ring Timeout */}
                            <Grid item xs={12} md={6}>
                              <TextField
                                fullWidth
                                label="Ring Timeout"
                                value={buyerData.ringTimeout}
                                onChange={(e) => {
                                  const numericValue = e.target.value.replace(
                                    /[^0-9]/g,
                                    "",
                                  );
                                  setBuyerData((prev) => ({
                                    ...prev,
                                    ringTimeout: numericValue,
                                  }));
                                }}
                                inputProps={{ inputMode: "numeric" }}
                              />
                            </Grid>

                            {/* Weightage */}
                            <Grid item xs={12} md={6}>
                              <TextField
                                fullWidth
                                label="Weightage"
                                value={buyerData.weightage}
                                onChange={(e) =>
                                  setBuyerData((prev) => ({
                                    ...prev,
                                    weightage: e.target.value,
                                  }))
                                }
                              />
                            </Grid>

                            {/* Daily Limit */}
                            <Grid item xs={12} md={6}>
                              <TextField
                                fullWidth
                                label="Daily Limit"
                                value={buyerData.dailyLimit}
                                onChange={(e) =>
                                  setBuyerData((prev) => ({
                                    ...prev,
                                    dailyLimit: e.target.value,
                                  }))
                                }
                              />
                            </Grid>

                            {/* Follow Work Time */}
                            <Grid item xs={12}>
                              <FormControl fullWidth>
                                <InputLabel>Follow Work Time</InputLabel>
                                <Select
                                  style={{ textAlign: "left" }}
                                  label="Follow Work Time"
                                  value={buyerData.followWorkTime}
                                  onChange={(e) =>
                                    setBuyerData((prev) => ({
                                      ...prev,
                                      followWorkTime: e.target.value,
                                    }))
                                  }
                                >
                                  <MenuItem value={true}>Yes</MenuItem>
                                  <MenuItem value={false}>No</MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>

                            {/* Start Time */}
                            <Grid item xs={12}>
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <MobileTimePicker
                                  label="Working Start Time"
                                  value={
                                    buyerData.fromDate
                                      ? dayjs(buyerData.fromDate, "HH:mm")
                                      : null
                                  }
                                  onChange={handleFromDateChange}
                                  slotProps={{
                                    textField: {
                                      fullWidth: true,
                                      error: Boolean(errors.fromDate),
                                      helperText: errors.fromDate,
                                      InputProps: {
                                        startAdornment: (
                                          <InputAdornment position="start">
                                            <AccessTimeIcon />
                                          </InputAdornment>
                                        ),
                                      },
                                    },
                                  }}
                                />
                              </LocalizationProvider>
                            </Grid>

                            {/* End Time */}
                            <Grid item xs={12}>
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <MobileTimePicker
                                  label="Working End Time"
                                  value={
                                    buyerData.toDate
                                      ? dayjs(buyerData.toDate, "HH:mm")
                                      : null
                                  }
                                  onChange={handleToDateChange}
                                  slotProps={{
                                    textField: {
                                      fullWidth: true,
                                      error: Boolean(errors.toDate),
                                      helperText: errors.toDate,
                                      InputProps: {
                                        startAdornment: (
                                          <InputAdornment position="start">
                                            <AccessTimeIcon />
                                          </InputAdornment>
                                        ),
                                      },
                                    },
                                  }}
                                />
                              </LocalizationProvider>
                            </Grid>
                          </Grid>
                        </form>
                      </DialogContent>
                      <DialogActions
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          paddingBottom: "20px",
                        }}
                      >
                        <Button
                          variant="contained"
                          className="all_button_clr"
                          color="primary"
                          sx={{
                            fontSize: "16px !impotant",
                            background: "#092b5f",

                            marginLeft: "10px !important",
                            padding: "10px 20px !important",
                            textTransform: "capitalize !important",
                          }}
                          onClick={handleSubmitBuyer}
                        >
                          Save
                        </Button>
                      </DialogActions>
                    </Dialog>
                    {/* -----   Add Buyer Modal End   ----- */}
                    {/* ----------------------------------------------
                     ----------------------------------------------
                     ----------------------------------------------
                     ---------------------------------------------- */}
                    {/* -----   Edit Campaign Modal Start   ----- */}

                    <Dialog
                      open={edit}
                      className="custom_dailog_box_user"
                      onClose={handleEditCampaignClose}
                      sx={{ textAlign: "center" }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          paddingTop: "10px",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography
                          className="modal_heading"
                          sx={{
                            color: "#133325",
                            fontWeight: "600",
                            width: "500px",
                          }}
                        >
                          Update Campaign
                        </Typography>
                        <IconButton
                          className="close_icon"
                          onClick={handleEditCampaignClose}
                          sx={{ float: "inline-end" }}
                        >
                          <Close />
                        </IconButton>
                      </Box>

                      <DialogContent>
                        <form>
                          <form
                            style={{
                              textAlign: "center",
                              paddingTop: "10px",
                              padding: "5px",
                              width: "auto",
                            }}
                          >
                            <TextField
                              style={{ width: "100%", margin: " 5px 0 5px 0" }}
                              type="text"
                              label="Campaign Name"
                              variant="outlined"
                              name="campaignName"
                              value={campaignName}
                              onChange={handleChange}
                            />
                            <FormControl
                              fullWidth
                              style={{
                                width: "100%",
                                margin: "7px 0",
                              }}
                            >
                              <InputLabel id="demo-simple-select-label">
                                Call Threading
                              </InputLabel>

                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                label="Call Threading"
                                helperText="Select the language."
                                style={{ textAlign: "left" }}
                                value={callThreading}
                                onChange={(e) => {
                                  setCallThreading(e.target.value);
                                }}
                              >
                                <MenuItem value={true}>Yes</MenuItem>
                                <MenuItem value={false}>No</MenuItem>
                              </Select>
                            </FormControl>
                            <br />
                            <FormControl
                              fullWidth
                              style={{
                                width: "100%",
                                margin: "7px 0",
                              }}
                            >
                              <InputLabel id="demo-simple-select-label">
                                Route Info
                              </InputLabel>

                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                label="Call Threading"
                                helperText="Select the language."
                                style={{ textAlign: "left" }}
                                value={routeInfo}
                                onChange={(e) => {
                                  setRouteInfo(e.target.value);
                                }}
                              >
                                <MenuItem value={true}>Active</MenuItem>
                                <MenuItem value={false}>Deactive</MenuItem>
                              </Select>
                            </FormControl>
                            <TextField
                              style={{ width: "100%", margin: " 5px 0 5px 0" }}
                              type="text"
                              label="Description"
                              variant="outlined"
                              name="description"
                              value={description}
                              onChange={handleChange}
                            />
                          </form>
                        </form>
                      </DialogContent>
                      <DialogActions
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          paddingBottom: "20px",
                        }}
                      >
                        <Button
                          variant="contained"
                          className="all_button_clr"
                          color="primary"
                          sx={{
                            fontSize: "16px !impotant",
                            marginTop: "0px",
                            padding: "10px 20px !important",
                            textTransform: "capitalize !important",
                          }}
                          onClick={handleUpdate}
                        >
                          Update
                        </Button>
                      </DialogActions>
                    </Dialog>

                    {/* -----   Edit Campaign Modal End   ----- */}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      {/* </div> */}
    </>
  );
}

export default Campaigns;
